/**
 * core/types/DataObject
 * ----------------------------------------------------------------------
 * @since     0.0.1
 */
export class DataObject {
  /**
   * Se o valor é nulo ou indefinido.
   * 
   * @param {*} value 
   * @returns {boolean}
   * @static 
   */
  static isNullOrUndefined (value) {
    return (value === null || value === undefined);
  }

  /**
   * Converte em POJO.
   * 
   * @param {boolean} notNullOnly 
   *     Se deve ignorar valores nulos ou indefinidos
   * @returns {object}
   */
  toObject (notNullOnly = false) {
    let keys = Object.keys(this),
        returnable = {};

    for (let key of keys) {
      if (Array.isArray(this[key])) {
        if (
          notNullOnly === true 
            && DataObject.isNullOrUndefined(this[key])
        ) {
          continue;
        }

        let temp = [];

        for (let n = 0; n < this[key].length; n++) {
          let curr = this[key][n];

          if (curr.toObject !== undefined) {
            temp.push(curr.toObject(notNullOnly));
          } else if (curr.toJSON !== undefined) {
            temp.push(curr.toJSON(notNullOnly));
          } else {
            temp.push(curr);
          }
        }

        returnable[key] = temp;
      } else if (typeof this[key] !== "function") {
        if (
          notNullOnly === true 
            && DataObject.isNullOrUndefined(this[key])
        ) {
          continue;
        }

        returnable[key] = this[key];
      }
    }

    return returnable;
  }

  /**
   * Alias para `toObject`, converte em POJO. Usado por `JSON.stringify`.
   * 
   * @param {boolean} notNullOnly 
   *     Se deve ignorar valores nulos ou indefinidos
   * @returns {object}
   */
  toJSON (notNullOnly = false) {
    return this.toObject(notNullOnly);
  }
}
